import { Container } from "react-bootstrap";
import colorSharp from "../assets/img/color-sharp.png";
import "./About.css";

export const About = () => {
  const highlights = [
    {
      title: "Cloud & Infrastructure",
      subtitle: "AWS, Azure, Linux, Terraform, Ansible",
      description:
        "Provisioning cloud-native infrastructure on AWS and Azure using Terraform — from EC2 and ECS Fargate to production EKS clusters with VPC, managed node groups, and IAM OIDC.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
        </svg>
      ),
    },
    {
      title: "CI/CD & Automation",
      subtitle: "Jenkins, GitHub Actions, ArgoCD",
      description:
        "Building DevSecOps pipelines with conditional builds, vulnerability scanning (Trivy, npm audit), Docker image publishing, and GitOps-based continuous deployment.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      ),
    },
    {
      title: "Containers & Orchestration",
      subtitle: "Docker, Kubernetes, Helm, ECR",
      description:
        "Containerizing microservices and deploying to Amazon EKS using Helm charts, the App of Apps pattern, and External Secrets Operator for secure config management.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
    },
    {
      title: "Observability & System Health",
      subtitle: "Prometheus, Grafana, CloudWatch",
      description:
        "Implementing monitoring with ServiceMonitors, custom RED metrics, centralized logging, and alerting dashboards to ensure uptime and rapid issue triage.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      ),
    },
  ];

  return (
    <section className="about" id="about">
      <Container>
        <div className="about-shell">
          <div className="about-heading">
            <span className="about-kicker">About Me</span>
            <h2>Bridging Development with Resilient Cloud Infrastructure</h2>
          </div>

          <div className="about-body">
            <div className="about-bio">
              <p>
                I'm a{" "}
                <strong>
                  BICT (Hons) graduate specializing in Software Systems
                </strong>{" "}
                from the <strong>University of Kelaniya, Sri Lanka</strong>.
                My foundation in software development was shaped through a
                hands-on internship where I worked across the full development
                lifecycle from gathering requirements to testing, debugging,
                and preparing applications for production.
              </p>
              <p>
                That experience sparked a deeper interest in what happens after
                the code is written: how software gets built, shipped, and kept
                running reliably at scale. This led me to focus on{" "}
                <strong>DevOps and Cloud Engineering</strong>, where I now
                channel my energy into designing infrastructure, automating
                deployments, and building systems that teams can depend on.
              </p>
              <p>
                I'm passionate about bridging the gap between software
                engineering and system operations. Whether it's setting up
                deployment pipelines, orchestrating containerized workloads, or
                building observability into every layer of a system, I care
                about making the entire delivery process smoother, faster, and
                more resilient.
              </p>
            </div>

            <div className="about-highlights-grid">
              {highlights.map((item, index) => (
                <div className="about-highlight-card" key={index}>
                  <div className="about-highlight-icon-box">{item.icon}</div>
                  <div className="about-highlight-content">
                    <h3 className="about-highlight-title">{item.title}</h3>
                    <span className="about-highlight-tags">{item.subtitle}</span>
                    <p className="about-highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};

